import { Metric } from '@shared/types';
import api from '@shared/api';

type FetchArgs = {
  experimentKey: string;
  signal?: AbortSignal;
};
const metricsApi = {
  fetchMetrics({ experimentKey }: FetchArgs) {
    const url = `data-fetch/get/metrics`;

    return api.get<{
      results: Metric[];
      version: string;
    }>(url, {
      params: { experimentKey }
    });
  }
};
export default metricsApi;
